module.exports = __webpack_public_path__ + "static/media/emo5b.7a5203fa.png";